import { render, staticRenderFns } from "./filesdata copy.vue?vue&type=template&id=5c226043&"
import script from "./filesdata copy.vue?vue&type=script&lang=js&"
export * from "./filesdata copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports